"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGroup = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var core_1 = require("@material-ui/core");
var RadioGroup = function (_a) {
    var children = _a.children, name = _a.name, onChange = _a.onChange, value = _a.value, _b = _a.isRow, isRow = _b === void 0 ? false : _b;
    return (react_1.default.createElement(core_1.FormControl, { component: "fieldset" },
        react_1.default.createElement(core_1.RadioGroup, { "data-signa": "radio-group-".concat(name), "aria-label": name, name: name, value: value, onChange: onChange, row: isRow }, children)));
};
exports.RadioGroup = RadioGroup;
